exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".video-page-modal--div .ant-modal-body {\n  padding: 0px;\n}\n.video-page-wrapper--div {\n  margin: 35px 0;\n}\n.video-page-wrapper--div .video-page-link--img {\n  cursor: pointer;\n}\n.ant-modal-close-x {\n  color: #ed1849;\n}\n", ""]);

